import { render, staticRenderFns } from "./BarcodesDisassemblyHistory.vue?vue&type=template&id=56c83927&scoped=true&"
import script from "./BarcodesDisassemblyHistory.vue?vue&type=script&lang=js&"
export * from "./BarcodesDisassemblyHistory.vue?vue&type=script&lang=js&"
import style0 from "./BarcodesDisassemblyHistory.vue?vue&type=style&index=0&id=56c83927&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c83927",
  null
  
)

export default component.exports